export const UIBlurEffectStyles = {
  // Adaptable Styles -------------------------------
  systemUltraThinMaterial: "systemUltraThinMaterial",
  systemThinMaterial     : "systemThinMaterial"     ,
  systemMaterial         : "systemMaterial"         ,
  systemThickMaterial    : "systemThickMaterial"    ,
  systemChromeMaterial   : "systemChromeMaterial"   ,
  // Light Styles ---------------------------------------------
  systemMaterialLight         : "systemMaterialLight"         ,
  systemThinMaterialLight     : "systemThinMaterialLight"     ,
  systemUltraThinMaterialLight: "systemUltraThinMaterialLight",
  systemThickMaterialLight    : "systemThickMaterialLight"    ,
  systemChromeMaterialLight   : "systemChromeMaterialLight"   ,
  // Dark Styles --------------------------------------------
  systemChromeMaterialDark   : "systemChromeMaterialDark"   ,
  systemMaterialDark         : "systemMaterialDark"         ,
  systemThickMaterialDark    : "systemThickMaterialDark"    ,
  systemThinMaterialDark     : "systemThinMaterialDark"     ,
  systemUltraThinMaterialDark: "systemUltraThinMaterialDark",
  // Additional Styles ----
  regular   : "regular"   ,
  prominent : "prominent" ,
  light     : "light"     ,
  extraLight: "extraLight",
  dark      : "dark"      ,
};

export const UIModalPresentationStyles = {
  automatic         : 'automatic'     ,
  fullScreen        : 'fullScreen'    ,
  pageSheet         : 'pageSheet'     ,
  formSheet         : 'formSheet'     ,
  overFullScreen    : 'overFullScreen',
  /* NOT SUPPORTED
  none              : 'none'              ,
  currentContext    : 'currentContext'    ,
  custom            : 'custom'            ,
  overCurrentContext: 'overCurrentContext',
  popover           : 'popover'           ,
  blurOverFullScreen: 'blurOverFullScreen',
  */
};

export const UIModalTransitionStyles = {
  coverVertical : 'coverVertical' ,
  crossDissolve : 'crossDissolve' ,
  flipHorizontal: 'flipHorizontal',
  /* NOT SUPPORTED
  partialCurl   : 'partialCurl'   ,
  */
};

export const ModalEventKeys = {
  onModalBlur          : 'onModalBlur'          ,
  onModalFocus         : 'onModalFocus'         ,
  onModalShow          : 'onModalShow'          ,
  onModalDismiss       : 'onModalDismiss'       ,
  onModalDidDismiss    : 'onModalDidDismiss'    ,
  onModalWillDismiss   : 'onModalWillDismiss'   ,
  onModalAttemptDismiss: 'onModalAttemptDismiss',
};